import React, { useEffect, useState } from "react";
import Container from "components/Layout/Container";
import { Typography } from "antd";
import { useStore } from "_Store";
import { Steps, useStepper } from "../../../components/Ui/Stepper";
import { useNavigate } from "react-router-dom";
import Treasury from "./ TreasuryStep/index.jsx";
import CahierDate from "./CahierDate";
import CahierFarmParcel from "./CahierFarmParcel/index.jsx";
import CahierLabel from "./CahierLabel/index.jsx";
import CahierResume from "./CahierResume";
import { addCahier } from "services/api";
import {
  addCahierData,
  getCashTransactionInput,
  getPaymentMadeInOption,
} from "services/cachier.service";

const steps = [
  {
    label: "Libellé",
    value: "libelle",
    element: CahierLabel,
  },
  {
    label: "Date",
    value: "date",
    element: CahierDate,
  },
  {
    label: "Trésorerie",
    value: "tresor",
    element: Treasury,
  },
 /*  {
    label: "Champs / Culture",
    value: "culture",
    element: CahierFarmParcel,
  }, */
  {
    label: "Résumé",
    value: "resume",
    element: CahierResume,
  },
];
const CaheirSteps = (props) => {
  const navigate = useNavigate();
  const {
    state,
    setCahierTableDataResponse,
    setUtils,
    setEntriesAndExitsOptionList,
    setPaymentOption
  } = useStore();

  const { activeStep: step, handleNext, handleBack } = useStepper();
  const [dynamicSteps, manageSteps] = React.useState(steps);
  const CurrentSetForm = dynamicSteps[step].element;
  const allStepsCompleted = step === dynamicSteps.length;
  const isLastStep = step === dynamicSteps.length - 1;
  
  const handleAddFormData = async (data, save) => {
    if (save) {
      state.cahierData.push({
        ...state.cahierTableDataResponse,
        ...data,
      });
      const res = await addCahierData({
        ...state.cahierTableDataResponse,
        ...data,
      });
      if (res.data.success) {
        setCahierTableDataResponse({});
        navigate("/cahier-sheet");
      }
    }
    if (!isLastStep) {
      setCahierTableDataResponse({
        ...state.cahierTableDataResponse,
        ...data,
      });
      handleNext();
    } else {
      setUtils("loading", { spinning: true, primary: "" });
      navigate("/cahier-sheet");
      setTimeout(() => {
        handleNext();
        setCahierTableDataResponse({});
        setUtils("loading", { spinning: false, primary: "" });
      }, 1200);
    }
  };
  const commodities = state.userProfile?.commodities
  useEffect(() => {
    if(state.farmList?.length && commodities?.length){
      setCahierTableDataResponse({
        farmId:state.farmList?.[0]?.id,
        seed: JSON.parse(commodities?.[0] || {})?.value
      })
    }

    return () => {
      setCahierTableDataResponse({});
    };
  }, []);

  const handleAddToSteps = (newStep) => {
    const prevSteps = dynamicSteps;
    manageSteps([...prevSteps.slice(0, 3), newStep, ...prevSteps.slice(3)]);
  };

  const handleRemoveFromSteps = (value) => {
    manageSteps(
      dynamicSteps.filter((item) => item.value !== value)
    );
  };
 
  const getOptions = async () => {
    const res = await getCashTransactionInput();
    if (res.data.success) {
      setEntriesAndExitsOptionList(res.data.data)
    }
    const response = await getPaymentMadeInOption();
    if(response.data.success){
      setPaymentOption(response.data.data)
    }
  };

  useEffect(() => {
    getOptions();
  }, []);

  const stepContainer = (WrapperComponent) => {
    return (
      <WrapperComponent
        onSubmit={(pl, save) => handleAddFormData(pl, save)}
        onBack={handleBack}
        addToSteps={handleAddToSteps}
        removeFromSteps={handleRemoveFromSteps}
      />
    );
  };
  return (
    <Container>
      <div className="sm:w-1/4 bg-white">
        <div className="flex flex-col h-full justify-center py-10 sm:py-0">
          {!allStepsCompleted ? (
            <div className="pl-4 sm:pl-12">
              <div className="py-4">
                <Typography>Etape {step + 1} sur {dynamicSteps.length}</Typography>
              </div>
              <Steps steps={dynamicSteps} />
            </div>
          ) : (
            <div className="flex flex-col h-full items-center sm:px-12 pt-24 pb-16"></div>
          )}
        </div>
      </div>
      <div className="flex-1 flex justify-center">
        <div className="w-full ">
         { !allStepsCompleted && stepContainer(dynamicSteps[step].element) }
        </div>
      </div>
    </Container>
  );
};
export default CaheirSteps;
